"use client"
import { Badge, MenuItem, Text, Tooltip } from "@mantine/core"

import { clampString, needStringToBeClamped } from "@/lib/stringUtils"
import { Memo, observer, Show, useObservable } from "@legendapp/state/react"
import { syncStore$ } from "@/stores/sync.v2.store"
import classes from "./MenuItemUserData.module.css"

const MAX_COMPANY_NAME_CHARACTERS_BEFORE_CLAMPING = 22

const BASE_TEST_ID = "menu-item-user-data-"

export const MenuItemUserData = observer(function MenuItemUserData() {
  const state$ = useObservable({
    userCompanyName: () => syncStore$.userStatus.companyName.get() ?? "",
    userAccountID: () => syncStore$.userStatus.accountId.get() ?? -1,
    userIsAdmin: () => syncStore$.userStatus.isAdmin.get() ?? false,
    userIsOwner: () => syncStore$.userStatus.isOwner.get() ?? false,
    isCompanyNameClamped: () =>
      needStringToBeClamped({
        value: syncStore$.userStatus.companyName.get() ?? "",
        maxLength: MAX_COMPANY_NAME_CHARACTERS_BEFORE_CLAMPING,
      }),
    clampedCompanyName: () =>
      state$.isCompanyNameClamped.get()
        ? clampString({
            value: state$.userCompanyName.get(),
            maxLength: MAX_COMPANY_NAME_CHARACTERS_BEFORE_CLAMPING,
          })
        : "",
  })

  return (
    <MenuItem
      component="div"
      style={{ cursor: "default" }}
      classNames={{
        itemLabel: classes.itemLabel,
      }}
      data-testid={`${BASE_TEST_ID}container`}
    >
      <Show
        if={state$.isCompanyNameClamped}
        else={() => (
          <Text size="sm" lineClamp={1} truncate="end" data-testid={`${BASE_TEST_ID}company-name`}>
            {state$.userCompanyName.get()}
          </Text>
        )}
      >
        {() => (
          <Tooltip label={state$.userCompanyName.get()} position="left">
            <Text size="sm" lineClamp={1} truncate="end" data-testid={`${BASE_TEST_ID}company-name-tooltip`}>
              {state$.clampedCompanyName.get()}
            </Text>
          </Tooltip>
        )}
      </Show>
      <div className={classes.badgeContainer}>
        <Memo>
          {() => (
            <Text size="xs" c="dimmed" data-testid={`${BASE_TEST_ID}user-id`}>
              ID: {state$.userAccountID.get()}
            </Text>
          )}
        </Memo>
        <Badge
          color={state$.userIsAdmin.get() ? "grape" : state$.userIsOwner.get() ? "red" : "rBackBlue.9"}
          size="xs"
          className={classes.badge}
          classNames={{
            label: classes.badgeLabel,
          }}
          data-testid={`${BASE_TEST_ID}user-role`}
        >
          {state$.userIsAdmin.get() ? "Admin" : state$.userIsOwner.get() ? "Owner" : "User"}
        </Badge>
      </div>
    </MenuItem>
  )
})
